module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/iot-2015-05-28.paginators.json
// module id = 665
// module chunks = 4